export default __webpack_public_path__ + "static/media/figma.a34923be.svg";